import { connect } from 'react-redux';
import { getFormValues, reset, destroy } from 'redux-form';
import { Dispatch, bindActionCreators } from 'redux';
import { actions as uiActions } from 'ducks/ui';
import { IApplicationState } from 'ducks/reducers';
import ProductReceiptDetails from './Details';

const FORM_NAME = 'ProductReceiptDetails';

const mapStateToProps = (state: IApplicationState) => {
    return {
        formValues: getFormValues(FORM_NAME)(state),
    };
};

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
    {
        changeConfirmationDialog: uiActions.changeConfirmationDialog,
        resetForm: () => reset(FORM_NAME),
        destroyForm: () => destroy(FORM_NAME),
    },
    dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ProductReceiptDetails);
